type StepColorsProps = {
  active: boolean | undefined;
  completed: boolean | undefined;
};

export const getStepColors = ({ active, completed }: StepColorsProps) => {
  switch (true) {
    case active:
      return {
        iconColor: 'var(--step-active-text-color)',
        backgroundColor: 'var(--step-active-background-color)',
      };
    case completed:
      return {
        iconColor: 'var(--step-done-text-color)',
        backgroundColor: 'var(--step-done-background-color)',
      };
    default:
      return {
        iconColor: 'var(--step-disabled-text-color)',
        backgroundColor: 'var(--step-disabled-background-color)',
      };
  }
};
